export * from "./FHIRQueryRequestTemplates.js";
//# sourceMappingURL=index.js.map